// Route remote images through the on-demand resizer (functions/index.js: img,
// served at /img) so the storefront downloads appropriately-sized, WebP images
// instead of full-resolution originals. Only proxies hosts the resizer accepts;
// anything else (local assets, data URIs, SVGs, other hosts) is returned as-is.
const PROXY_HOSTS = [
  'firebasestorage.googleapis.com',
  'images.unsplash.com',
  'i.pravatar.cc',
];

export function cdnImage(url, width = 600, quality = 68) {
  if (!url || typeof url !== 'string' || !/^https:\/\//i.test(url)) return url;
  let host;
  try {
    host = new URL(url).hostname;
  } catch (_) {
    return url;
  }
  if (!PROXY_HOSTS.includes(host)) return url;
  return `/img?src=${encodeURIComponent(url)}&w=${width}&q=${quality}`;
}
